export enum Edge {
  start,
  end,
}
